export default "__VITE_ASSET__BlQCwr_6__"